"use client";

// External imports
import { useEffect, useState } from "react";
import NextLink from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";

// Local imports
import classes from "./style.module.css";
import languageConfig from "@/export/config";
import LeftArrowIcon from "@/app/assets/vectors/LeftArrowIcon";

export default function Header() {
  const pathname = usePathname();
  const pathNameExp = /^\/fonts\/.*\/$/;

  const [headerBackUrl, setHeaderBackUrl] = useState("");

  useEffect(() => {
    if (window.location.hash) {
      setHeaderBackUrl(
        `/fonts/#${decodeURIComponent(window.location.hash.split("#")[1])}`
      );
    } else {
      setHeaderBackUrl(`/fonts`);
    }
  }, []);

  return (
    <header className={`${classes.header}`}>
      <nav className={`${classes.container}`}>
        {pathNameExp.test(pathname) ? (
          <NextLink className={`${classes.link}`} href={headerBackUrl}>
            <LeftArrowIcon />
          </NextLink>
        ) : (
          <NextLink className={`${classes.link}`} href="/">
            <LeftArrowIcon />
          </NextLink>
        )}

        <NextLink className={`${classes.logo}`} href="/">
          <Image
            className={`${classes.icon}`}
            src="/icon.webp"
            alt={`${languageConfig?.app.name} icon`}
            width={512}
            height={512}
          />
          <h1 className={`${classes.heading}`}>{languageConfig?.app.name}</h1>
        </NextLink>
      </nav>
      <div className={`${classes.line}`}></div>
    </header>
  );
}
